// Bild-Cookie (Phase 6, Backend app/bild_zugang.py): /bilder/ liefert nur mit kurzlebigem Cookie der Familie aus.
// GET /ich setzt es bei jedem App-Start; hier wird es alle 6 h und nach einem abgewiesenen Bild erneuert.
import { api } from '../api/client';

let laufend: Promise<boolean> | null = null;
let zuletzt = 0;

export function bildSitzungErneuern(): Promise<boolean> {
  if (laufend) return laufend;
  // Ein kaputtes Bild soll nicht im Sekundentakt nachfragen
  if (Date.now() - zuletzt < 30_000) return Promise.resolve(false);
  zuletzt = Date.now();
  laufend = api<{ gueltig_bis: number }>('/bilder/sitzung', { method: 'POST' })
    .then(() => true)
    .catch(() => false)
    .finally(() => {
      laufend = null;
    });
  return laufend;
}

export const BILD_SITZUNG_TAKT_MS = 6 * 3600_000;
